import $req from "@/request"
import store from "@/store"
import { Modal } from "antd"
import moment from "moment"
import { modalContent, closeIcon } from '@/request'
import CryptoJS  from './crypto.js'
import { getKey } from '@/api';

let userType: string
let REACT_APP_SERECT_KEY = ''

export async function initSecretKey() {
  if(REACT_APP_SERECT_KEY) return
  const res = await getKey()
  REACT_APP_SERECT_KEY = res.resultMessage
}

export function getSecretKey() {
  return REACT_APP_SERECT_KEY?REACT_APP_SERECT_KEY:'AIAIRPASPROJECT_'
}


export const storage = {
	setItem: (key: string, value: any, type: string = 's'):void => {
	  if (type === 's') {
		window.sessionStorage.setItem(key, JSON.stringify(value))
	  } else {
		window.localStorage.setItem(key, JSON.stringify(value))
	  }
	},
	getItem: (key: string, type: string = 's'): any => {
	  let value
	  if (type === 's') {
		value = window.sessionStorage.getItem(key)
	  } else {
		value = window.localStorage.getItem(key)
	  }
	  if (!value) return null
	  return value
	},
	removeItem: (key: string, type: string = 's'):void => {
	  if (type === 's') {
		window.sessionStorage.removeItem(key)
	  } else {
		window.localStorage.removeItem(key)
	  }
	}
}

export const isMobile = navigator.userAgent.includes('AIA-Mobile')

export const isIOS = (): boolean => {
  return navigator.userAgent.includes('AIA-iOS')
}

export const isAndroid = (): boolean => {
  return navigator.userAgent.includes('AIA-Android')
}

export const getClientType = (): string => {
  if(isIOS()){
    return 'IOS'
  }else if(isAndroid()){
    return 'Android'
  }else{
    return 'Web'
  }
}


/**
 * 加密本地存储的数据
 * @param key 存储的键名
 * @param value 要加密的值
 * @param storageType 本地存储类型 s -> sessionStorage | l -> localStorage
 */
export const encryptText = (key: string, value: any, storageType: string = 's') => {
	if (!value) return undefined
  // console.log('encryptText:' +getSecretKey())
	// console.log(`将${value}进行加密存储`)
	let encryptValue
	if (typeof value === 'object') {
	  // console.log(`${value} 是对象`)
	  encryptValue = (CryptoJS as any).AES.encrypt(JSON.stringify(value), CryptoJS.enc.Utf8.parse(getSecretKey()), { mode: (CryptoJS as any).mode.ECB, padding: (CryptoJS as any).pad.Pkcs7 }).toString()
	} else {
	  encryptValue = (CryptoJS as any).AES.encrypt(value, CryptoJS.enc.Utf8.parse(getSecretKey()), { mode: (CryptoJS as any).mode.ECB, padding: (CryptoJS as any).pad.Pkcs7 }).toString()
	}
	// console.log(`${key} -- 加密后的密文 == ${encryptValue}`)
	storage.setItem(key, encryptValue, storageType)
}
  
/**
 * 解密本地存储的数据并返回
 * @param key 存储的键名
 * @param storageType 本地存储类型 s -> sessionStorage | l -> localStorage
 * @returns decrypt value
 */
export const decryptText = (key: string, storageType: string = 's') => {
	if (!storage.getItem(key, storageType)) return

  // console.log('decryptText:' +getSecretKey())
	let value
	if (!isMobile) {
		value = JSON.parse(storage.getItem(key, storageType))
	} else {
		value = storage.getItem(key, storageType).indexOf('\"') !== -1 ? JSON.parse(storage.getItem(key, storageType)) : storage.getItem(key, storageType)
	}
	// console.log(`${key} - 解密时取出来的值：${value} -- type: ${typeof value}`)
	const decryptValue = (CryptoJS as any).AES.decrypt(value, CryptoJS.enc.Utf8.parse(getSecretKey()), { mode: (CryptoJS as any).mode.ECB, padding: (CryptoJS as any).pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)
	// console.log(`${key} - 将数据解密之后的值：${decryptValue}`)

	if (!decryptValue) return ''

	const regTest = /[\[\]{}]/
	if (regTest.test(decryptValue)) return JSON.parse(decryptValue)

	if (isAndroid()){
		if (decryptValue.indexOf('\"') !== -1) {
		return JSON.parse(decryptValue)
		} else {
		return decryptValue
		}
	}

	return decryptValue
}

/**
 * 加密文本
 * @param value 加密的文本
 * @returns 加密后的结果
 */
export const encryptTextOnly = (value: any): string => {
	let encryptValue
  // console.log('encryptTextOnly:' +getSecretKey())
	if (typeof value === 'object') {
		// console.log(`${value} 是对象`)
		encryptValue = (CryptoJS as any).AES.encrypt(JSON.stringify(value), CryptoJS.enc.Utf8.parse(getSecretKey()), { mode: (CryptoJS as any).mode.ECB, padding: (CryptoJS as any).pad.Pkcs7 }).toString()
	} else {
		encryptValue = (CryptoJS as any).AES.encrypt(value, CryptoJS.enc.Utf8.parse(getSecretKey()), { mode: (CryptoJS as any).mode.ECB, padding: (CryptoJS as any).pad.Pkcs7 }).toString()
	}
	return encryptValue
}

/**
 * 加密文本
 * @param value 加密的文本
 * @returns 加密后的结果
 */
export const decryptTextOnly = (value: any): string => {
  // console.log('decryptTextOnly:' +getSecretKey())
	let decryptValue = (CryptoJS as any).AES.decrypt(value, CryptoJS.enc.Utf8.parse(getSecretKey()), { mode: (CryptoJS as any).mode.ECB, padding: (CryptoJS as any).pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)
	// console.log(`解密后的文本：${decryptValue}`)
	if (!decryptValue) return ''
	return JSON.parse(decryptValue)
}

if (decryptText('irpas_userType') === 'ee') {
	userType = 'EE'
} else if (decryptText('irpas_userType') === 'er') {
	userType = 'ER'
}

export const formatDate = (date: string):string => {
  let newDate = '';
  if (date) newDate = `${date.slice(6)}/${date.slice(4, 6)}/${date.slice(0,4)}`;
  return newDate;
}

/**
 * 
 * @param verifyUrl 检查文件地址
 * @param downloadUrl 下载文件地址
 * @param params 参数
 */
interface IDownloadParams {
  userId: string,
  fileName?: string,
  fileType?: string,
  period?:string
}

declare global {
  interface Window {
    webkit: any
  }
}
export const downloadFile = (verifyUrl: string, downloadUrl: string, params?: IDownloadParams, removeBtnLoading?: any, needPreviewPDF?: boolean, addUserType?: any) => {
  const isMobile = navigator.userAgent.includes('AIA-Mobile');
  const isIOS = navigator.userAgent.includes('AIA-iOS');
  const isAndriod = navigator.userAgent.includes('AIA-Android');
  const { language } = store.getState()
  return new Promise(async (resolve, reject) => {
    try {
      store.dispatch({
        type: 'TOOGLE_LOADING',
        payload: {
          loading: true
        }
      })
      const checkRes = await $req({url: verifyUrl, data: {...params, ...addUserType}, method: 'POST'})
      console.log(checkRes)
      if (checkRes.resultCode === '0') {
        if (!isMobile) {
          if (!needPreviewPDF) { // no need to preview PDF
            const downloadRes = await $req({url: downloadUrl, params:{...params, lang: language}, responseType: 'blob'})
            const {disposition} = downloadRes
            const fileName = decodeURI(decodeURI(disposition.slice(disposition.indexOf('filename=') + 9)))
            store.dispatch({
              type: 'TOOGLE_LOADING',
              payload: {
                loading: false
              }
            })
            const blob = new Blob([downloadRes.res])
            const downloadEle: HTMLAnchorElement = document.createElement('a')
            const href = window.URL.createObjectURL(blob)
            downloadEle.style.display = 'none'
            downloadEle.href = href
            downloadEle.download = fileName
            document.body.appendChild(downloadEle)
            downloadEle.click()
            document.body.removeChild(downloadEle)
            window.URL.revokeObjectURL(href)
            resolve({success: true, msg: 'download success'})
          } else { // need preview PDF
            store.dispatch({
              type: 'TOOGLE_LOADING',
              payload: {
                loading: false
              }
            })
            const pdfUrl =  `${downloadUrl}?userId=${params?.userId}${params?.fileName ? `&fileName=${params?.fileName}` : ''}${params?.fileType ? `&fileType=${params?.fileType}` : ''}&lang=${language}`
            resolve({
              success: true,
              msg: `download success, let's preview PDF now`,
              needPreviewPDF: true,
              pdfUrl
            })
          }
        } else {
          console.log('走移动端的下载')
          const downloadUrlTOOC = `/${process.env.REACT_APP_CONTEXT_PATH}/rest${downloadUrl}?userId=${params?.userId}${params?.fileName ? `&fileName=${params?.fileName}` : ''}${params?.fileType ? `&fileType=${params?.fileType}` : ''}${params?.period ? `&period=${params?.period}` : ''}`
          console.log(downloadUrlTOOC)
          if (isIOS) { // this is iOS
            window.webkit.messageHandlers.WKNativeMethodMessage.postMessage({
              downloadUrl: downloadUrlTOOC,
              fileName: params?.fileName || '',
              actionName: 'download',
              needPreviewPDF
            })
            removeBtnLoading && removeBtnLoading()
          } else if (isAndriod) { // this is Android
            (window as any).sentToAndroid.downloadFile(JSON.stringify({
              downloadUrl: downloadUrlTOOC,
              fileName: params?.fileName || '',
              needPreviewPDF
            }))
            removeBtnLoading && removeBtnLoading()
          }
          store.dispatch({
            type: 'TOOGLE_LOADING',
            payload: {
              loading: false
            }
          })
        }
      } else if (checkRes.resultCode && checkRes.resultCode === '500') {
        store.dispatch({
          type: 'TOOGLE_LOADING',
          payload: {
            loading: false
          }
        })
        Modal.error({
          className: `warning-modal${!isMobile ? ' warning-modal-no-btn' : ''}`,
          centered: true,
          closable: !isMobile,
          width: !isMobile ? 640 : 360,
          maskClosable:true,
          content: modalContent(require('@/assets/img/icon/icon_warning.png'), 'Your request cannot be handled at the moment. Please try again later.'),
          closeIcon: closeIcon(),
        })
        // resolve({success: false, checkRes: checkRes.resultMessage})
      } else {
        store.dispatch({
          type: 'TOOGLE_LOADING',
          payload: {
            loading: false
          }
        })
        resolve({success: false, checkRes: checkRes.resultMessage})
      }
    } catch (error) {
      console.error(error)
      store.dispatch({
        type: 'TOOGLE_LOADING',
        payload: {
          loading: false
        }
      })
      reject(error)
    }
  })
}

export const formatAllDate = (date:string):string => {
  let newDate = ''
  if (date) newDate = `${moment(date.slice(0,8)).format('DD/MM/YYYY')} ${date.slice(8, date.length)}` 
  return newDate;
}

export const formatYM = (date:string):string => {
  let newDate = ''
  if (date) newDate = `${date.slice(4,6)}/${date.slice(0,4)}`;
  return newDate
}

export const numFormatFloat = (data: string):string => {
  return data = parseFloat(data).toFixed(2); 
}


export const numFormatInt = (data:string):number => {
  return parseInt(data);
}


/**
 * 校验是否含有特殊字符
 * @param text string
 * @returns boolean
 */
export const hasSpecialCharacter = (text: string): boolean => {
  const reg = /[(|&;@'"\\<>()+)]/
  if (reg.test(text)) {
    return true
  } else {
    return false
  }
}

export const validatePwd = (password: string, userId: string): 'Y' | 'N' => {
  const regRule1 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[_\*/!\?=\{\}\[\]-])[\da-zA-Z_!=\*/\?\{\}\[\]-]{9,15}$/; // 字母大小写、数字、特殊字符-_*/!?={}[]
  const regRule2 = /([\w])\1{2}/ // 不能三个或三个相同字符，如111 aaa AAA
  const checkContinuousCharacter = (str: string): boolean => { // 不能三个及三个以上连续字符
      const arr = str.split('')
      for (let i = 1; i < arr.length - 1; i++) {
          let diff = str.charCodeAt(i) - str.charCodeAt(i - 1)
          if (Math.abs(diff) === 1 && (str.charCodeAt(i + 1) - str.charCodeAt(i)) === diff) {
              return false
          }
      }
      return true
  }

  const value = password
  if (value) {
      if (value.length < 9 || value.length > 15) {
          return "N"
      } else if (hasSpecialCharacter(value)) {
          return "N"
      }  else if (!regRule1.test(value)) {
          console.log('没有包含大写或小写字母及特殊字符')
          return "N"
      } else if (regRule2.test(value) ) {
          console.log('有三个及三个以上相同字符')
          return "N"
      } else if (!checkContinuousCharacter(value)) {
          console.log('有三个及三个以上连续的字符串')
          return "N"
      } else if (value === userId) {
          //  Not be derivative of internet user ID
          return "N"
      } else {
          return "Y"
      }
  } else {
      return "N"
  }
}

export const DOWNLOAD_SHEET_NAME = 'icon_menu_fund_fact_sheet.png'

export const DEFAULT_TIME_COUNT_DOWN = 60
export const DEFAULT_COUNTRY_CODE = '66' 

export const formatEmail = (email: string): string => email.replace('@', '^-^')
export const RegEmail = /^[\w\-_+\.]+@[\w]+\.[\w]{2,}$/
